import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type CampaignFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const CampaignFilled = forwardRef<SVGSVGElement, CampaignFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-5.181307 -4.227235) scale(1.352943)">
        <path d="M17.3042 16.8048C15.1792 14.3541 7.73506 14.5234 7.60894 13.7603V8.20326C7.73408 7.12513 13.7119 7.59862 16.8373 4.70802C19.9962 1.78679 21.1992 7.3745 21.1992 11.1947C21.1992 15.0144 19.447 19.2765 17.3042 16.8048ZM4.19922 12.1788V9.36283C4.19922 8.74057 4.70555 8.23612 5.33001 8.23612H6.47784V13.3057H5.33001C4.70557 13.3057 4.19922 12.8013 4.19922 12.1788ZM8.94237 15.3394C9.73999 15.4985 10.3379 15.7442 10.3379 15.7442C10.3379 15.7442 10.5933 16.4466 11.2857 17.4216C12.1185 18.5939 13.1559 20.0874 11.9725 20.0874C11.5926 20.0874 11.2624 20.0945 10.9429 20.0945C9.96587 20.0945 9.39931 19.396 8.46385 17.8016C7.40138 15.9901 7.66663 15.0617 7.66663 15.0617C7.66663 15.0617 8.14493 15.1805 8.94237 15.3394Z" />
      </g>
    </svg>
  ),
);

CampaignFilled.displayName = 'CampaignFilled';

export default CampaignFilled;
